import React from 'react';
import styles from "../../styles/Features.module.css";
import {Card, CardContent, CardHeader, CardMedia} from "@mui/material";

const FeatureCardItem = ({image, name, text}) => {
    return (
        <Card elevation={2} sx={{maxWidth: 300}} className={styles.featureItem}>
            <CardMedia
                component="img"
                alt={name}
                height="150"
                width="150"
                image={image}
            />
            <CardHeader title={name} className={styles.featureItemHeader}/>
            <CardContent>
                {text}
            </CardContent>
        </Card>
    );
};

export default FeatureCardItem;

